import { ArrowLeftRight, LogOut } from 'lucide-react';
import { useAuthStore } from '../../stores/authStore';
import { authService } from '../../services/auth.service';

const AssumeIdentityBanner = () => {
  const { user, isAssumedIdentity, returnToOriginal, getVSNToken } = useAuthStore();

  if (!isAssumedIdentity()) return null;

  const handleReturn = async () => {
    // Revoke the assumed session before restoring
    try {
      const currentToken = getVSNToken();
      if (currentToken) {
        await authService.logoutVSN();
      }
    } catch {
      // Best effort — continue even if revoke fails
    }

    returnToOriginal();
    window.location.reload();
  };

  return (
    <div className="bg-amber-500 text-white px-4 py-2 flex items-center justify-between text-sm z-50">
      <div className="flex items-center space-x-2">
        <ArrowLeftRight className="w-4 h-4" />
        <span>
          Viewing as <strong>{user?.email}</strong>
          {user?.type === 5 ? (
            <span className="ml-1 opacity-90">(Channel Admin)</span>
          ) : (
            user?.tenantName && (
              <span className="ml-1 opacity-90">({user.tenantName})</span>
            )
          )}
        </span>
      </div>
      <button
        onClick={handleReturn}
        className="flex items-center space-x-1.5 bg-amber-600 hover:bg-amber-700 px-3 py-1 rounded text-white font-medium transition-colors"
      >
        <LogOut className="w-3.5 h-3.5" />
        <span>Return to Admin</span>
      </button>
    </div>
  );
};

export default AssumeIdentityBanner;
